var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{ref:"expression-editor",staticClass:"ignore-key-press",style:(_vm.editorStyle),on:{"keydown":function($event){$event.stopPropagation();}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }